<template>
  <ion-app>
    <ion-router-outlet />
  </ion-app>
</template>

<script>
import { IonApp, IonRouterOutlet } from '@ionic/vue';
import { defineComponent } from 'vue';
import update from './mixins/update';

export default defineComponent({
  name: 'App',
  mixins: [update],
  components: {
    IonApp,
    IonRouterOutlet
  },
  methods: {
    updateAvailable (event) {
      console.log('refresh triggered');
      this.registration = event.detail;
      this.updateExists = true;
      this.refreshApp();
    },
  }
});
</script>